<template>
  <div iv id="sweetCalendar">
    <div class="container calendar">
      <div :class="[arrow ? 'header-no-arrow' : 'header']">
        <el-button
          v-if="!arrow"
          plain
          icon="el-icon-d-arrow-left"
          @click="prevMonth"
          round
        >
        </el-button>
        <div class="month">{{ selectedMonthName }} {{ selectedYear }}</div>
        <el-button
          v-if="!arrow"
          plain
          icon="el-icon-d-arrow-right"
          @click="nextMonth"
          round
          size="small"
        >
        </el-button>
      </div>
      <div class="body">
        <div
          v-for="(day, index) in weekdays"
          :key="`day-name-${index + 1}`"
          class="day-name"
        >
          {{ day }}
        </div>
        <div v-for="(day, index) in days" :key="index" class="day-container">
          <div class="before" v-if="day" :style="generateBeforeStyle(day)">
            &nbsp;
          </div>
          <div
            @click="goToEvents(day)"
            v-if="day"
            :class="[
              'day',
              `day-${day.getDate()},
            weekday-${day.getDay()}`,
              offDays.includes(day.getDay()) ? 'off-day' : null,
              day.toDateString() === today.toDateString() ? 'today' : null,
            ]"
            :style="generateDayStyle(day)"
          >
            <span>{{ day.getDate() }}</span>
          </div>
          <div class="after" v-if="day" :style="generateAfterStyle(day)">
            &nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DateTime from "../DateTime.js";
import { mapMutations, mapState } from "vuex";
import moment from 'moment';
export default {
  name: "sweetCalendar",
  data() {
    return {
      today: new DateTime(),
      date: "",
      weekdays: null,
    };
  },
  watch: {
    initialDate: function (val) {
      this.date = new DateTime(val);
    },
  },
  computed: {
    ...mapState({
      selectedDate: state => state.journal.selectDate
    }),
    days() {
      let emptyDays = Array(
        (this.startWeekDayOfMonth - this.firstDayOfWeek + 7) % 7
      ).fill(null);
      let days = Array(this.numberOfDays)
        .fill()
        .map(
          (item, index) =>
            new DateTime(this.selectedYear, this.selectedMonth, index + 1)
        );
      return emptyDays.concat(days);
    },
    startWeekDayOfMonth() {
      return this.date.getFirstWeekdayOfMonth();
    },
    numberOfDays() {
      return this.date.getNumberOfDaysInMonth();
    },
    selectedMonth() {
      return this.date.getMonth();
    },
    selectedMonthName() {
      return this.date.getMonthName();
    },
    selectedYear() {
      return this.date.getFullYear();
    },
    prevMonthData() {
      return new DateTime(this.selectedYear, this.selectedMonth - 1, 1);
    },
    selectedEvent() {
      return this.$store.state.journal.selectDate;
    },
  },
  methods: {
    ...mapMutations({
      setSelectDate: "journal/SET_SELECT_DATE",
      setSelectEvent: "journal/SET_SELECT_EVENT",
    }),

    goToEvents(day) {
      let dayCurrent = day.getDate() < 10 ? "0" + day.getDate() : day.getDate();
      let monthCurrrent =
        day.getMonth() < 10 ? "0" + day.getMonth() : day.getMonth();
      let currentDate = `${day.getFullYear()}-${monthCurrrent}-${dayCurrent}`;
      let eventsArray = [];
      this.events.forEach((el) => {
        if (el.date === currentDate) {
          eventsArray.push(el);
        }
      });
      this.setSelectDate(day);
      this.setSelectEvent(eventsArray);
    },
    prevMonth() {
      this.date = new DateTime(this.selectedYear, this.selectedMonth - 1, 1);
      this.$emit("prevMonth", this.date);
    },
    nextMonth() {
      this.date = new DateTime(this.selectedYear, this.selectedMonth + 1, 1);
      this.$emit("nextMonth", this.date);
    },
    generateWeekdayNames(firstDayOfWeek = 1) {
      let weekdays = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];
      for (let i = 2; i <= firstDayOfWeek; i++) {
        let first = weekdays.shift();
        weekdays.push(first);
      }
      return weekdays;
    },
    generateDayStyle(date) {
      let style = {};
      for (let event of this.events) {
        if (date.isInRange(event.date, event.date, event.repeat)) {
          let category =
            this.eventCategories.find((item) => item.id === event.categoryId) ||
            {};
          Object.assign(style, {
            color: category.id ? category.textColor : null,
            backgroundColor: category.id ? category.backgroundColor : null,
            fontWeight: category.id ? "bold" : "normal",
          });
        }

        if (this.selectedDate && moment(this.selectedDate.toISOString()).format('YYYY-MM-DD') === moment(date.toISOString()).format('YYYY-MM-DD')) {
          style.backgroundColor = '#000';
          style.color = '#fff';
        }
      }
      return style;
    },
    generateBeforeStyle(date) {
      let style = {};
      for (let event of this.events) {
        if (
          date.isInRange(event.start, event.end, event.repeat) &&
          date.getPrevDay().isInRange(event.start, event.end, event.repeat)
        ) {
          let category =
            this.eventCategories.find((item) => item.id === event.categoryId) ||
            {};
          Object.assign(style, {
            backgroundColor: category.backgroundColor,
          });
        }
      }
      return style;
    },
    generateAfterStyle(date) {
      let style = {};
      for (let event of this.events) {
        if (
          date.isInRange(event.start, event.end, event.repeat) &&
          date.getNextDay().isInRange(event.start, event.end, event.repeat)
        ) {
          let category =
            this.eventCategories.find((item) => item.id === event.categoryId) ||
            {};
          Object.assign(style, {
            backgroundColor: category.backgroundColor,
          });
        }
      }
      return style;
    },
    goToday() {
      this.date = this.today;
    },
    goSelectDate() {
      this.date = this.$store.state.journal.selectDate;
    },
  },
  props: {
    initialDate: {
      type: String,
      default: null,
    },
    arrow: {
      type: Boolean,
      default: false,
    },
    firstDayOfWeek: {
      type: Number,
      default: 1, // 1: Sunday, 2: Monday, etc
    },
    eventCategories: {
      type: Array,
      default() {
        return [];
      },
    },
    events: {
      type: Array,
      default() {
        return [];
      },
    },
    offDays: {
      type: Array,
      default() {
        return [1, 7];
      },
    },
  },
  beforeMount() {
    this.date = Date.parse(this.initialDate)
      ? new DateTime(this.initialDate)
      : new DateTime();
    this.weekdays = this.generateWeekdayNames(this.firstDayOfWeek);
  },
};
</script>

<style lang="scss">
#sweetCalendar {
  box-sizing: border-box;
  .container {
    display: grid;
    grid-template-rows: 80px 1fr;
    height: 100%;
    .header {
      justify-items: center;
      align-items: center;
      display: grid;
      grid-column-gap: 5px;
      grid-template-columns: 1fr 1fr 1fr;
      justify-items: center;

      .el-icon-d-arrow-left,
      .el-icon-d-arrow-right {
        font-size: 18px;
      }
      .left-arrow,
      .right-arrow {
        align-items: center;
        width: 80%;
        height: 80%;
        border-radius: 10px;
        cursor: pointer;
        border: 1px solid $placeholder-text-clr;
      }
      .el-button {
        padding: 0;
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }
    .month {
      text-align: center;
      justify-self: center;
      &:first-letter {
        text-transform: uppercase;
      }
    }
    .header-no-arrow {
      display: grid;
      justify-content: center;
      align-items: center;
    }
    .body {
      align-items: center;
      display: grid;
      grid-row-gap: 8px;
      grid-template-columns: repeat(7, 1fr);
      grid-template-rows: repeat(7, 1fr);
      justify-items: center;

      .day-name {
        color: $regular-text-clr;
        font-weight: bold;
      }
      .day-container {
        display: grid;
        grid-auto-columns: 1fr 1fr;
        grid-auto-flow: column;
        height: 28px;
        position: relative;
        width: 100%;

        .day {
          align-content: center;
          border-radius: 50%;
          box-sizing: content-box;
          color: $regular-text-clr;
          display: grid;
          height: 8px;
          justify-content: center;
          left: 50%;
          padding: 10px;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 8px;
          cursor: pointer;
          &.today {
            border: 2px solid $regular-text-clr;
            color: $regular-text-clr;
          }
          &.off-day {
            background-color: $danger-clr;
            font-weight: bold;
            color: $basic-white;
          }
          span {
            font-size: 14px;
            margin: 0;
            padding: 0;
            width: fit-content;
          }
        }
      }
    }
  }
  .calendar {
    background-color: inherit;

    .body {
      .day-container {
        .before {
          height: 28px;
        }
        .after {
          height: 28px;
        }
      }
    }
  }
}
</style>
